<div class="container-fluid content-padded">
  <div class="row">
    <div class="col-md-12 container">
      <div class="edit-header">
        <h3 class="user-title mt-3">{{'Manage Your Account' | translate}}</h3>
      </div>
      <div class="container" *ngIf="formCreated">
        <app-user-form [action]='action' [formContent]='userDetails' (onSubmitSuccess)="onSubmitSuccess($event)"></app-user-form>
      </div>
    </div>
  </div>
</div>
